import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormInput } from "../../../components";
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { authStaff, formatName } from "../../../utils/constants";
import { fetchRequests } from "../../../Requests/getRequests";
import { show } from '../../../slices/toastSlice';
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';
import { Loader } from "../../../components";

function Alias({ staff, setStaff }) {

    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [first_name, setFirst_name] = useState(staff?.otherNames);
    const [last_name, setLast_name] = useState(staff?.surname);
    const [phone, setPhone] = useState(staff?.phone);
    const [email, setEmail] = useState(staff?.email);
    const [process, setProcess] = useState(false);

    const handleRequest = async (e) => {
        e.preventDefault();
        setProcess(true);

        const res = await fetchRequests(`/auth/staff/update`, "PUT", authStaff(accessToken), {}, {
            _id: staff?._id,
            otherNames: formatName(first_name),
            surname: formatName(last_name),
            phone,
            email,
        });
        setProcess(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }

        dispatch(show({ type: "success", state: true, message: res?.message }));
        const staffRes = await fetchRequests(`/auth/staff/find`, "GET", authStaff(accessToken), { _id: staff?._id }, {});
        if (!staffRes?.code) setStaff(staffRes);
    };

    return (
        <form onSubmit={handleRequest} className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <FormInput
                    label="First Name"
                    name="first_name"
                    id="first_name"
                    type="text"
                    value={first_name}
                    setValue={setFirst_name}
                />
                <FormInput
                    label="Last Name"
                    name="last_name"
                    id="last_name"
                    type="text"
                    value={last_name}
                    setValue={setLast_name}
                />
                <FormInput
                    label="Phone Number"
                    name="phone"
                    id="phone"
                    type="text"
                    value={phone}
                    setValue={setPhone}
                />
                <FormInput
                    label="Email Address"
                    name="email"
                    id="email"
                    type="email"
                    value={email}
                    setValue={setEmail}
                />
            </div>

            <div className="flex items-center gap-3 pt-1">
                <button
                    type="submit"
                    disabled={process}
                    className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-[#1e3a6e] rounded-lg hover:bg-[#264d91] disabled:opacity-50 transition-colors"
                >
                    {process ? <Loader color="text-white" size="w-4 h-4" /> : <HugeiconsIcon icon={ArrowRight01Icon} size={15} />}
                    Save Changes
                </button>
            </div>
        </form>
    );
}

export default Alias;
